import { ArrowUp } from 'lucide-react';
import { useScrolled } from '../hooks/useScrolled';

const BackToTop = () => {
  const show = useScrolled(600);

  return (
    <button
      data-testid="back-to-top-button"
      tabIndex={show ? 0 : -1}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-5 right-5 sm:bottom-6 sm:right-[210px] z-[80] w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-primary hover:bg-primary-hover text-primary-foreground shadow-lg shadow-primary/25 flex items-center justify-center transition-all duration-300 ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      aria-label="Yukari cik"
    >
      <ArrowUp size={18} strokeWidth={2.4} />
    </button>
  );
};

export default BackToTop;
